export default __webpack_public_path__ + "static/media/white-logo-trans.af59b4b0.png";